import React from 'react';

export enum BUTTON_TYPE {
    PRIMARY = 'isPrimary',
    SECONDARY = 'isSecondary',
    ADVANCED = 'isAdvanced',
    LINK = 'isLink',
    PLAIN = 'isPlain',
    DANGER = 'isDanger',
    SUCCESS = 'isSuccess',
}

export enum BUTTON_HTML_TYPE {
    BUTTON = 'button',
    SUBMIT = 'submit',
    RESET = 'reset',
}

export enum BUTTON_SIZE {
    DEFAULT = 'isDefault',
    BIG = 'isBig',
}

type ButtonColorStyle = {
    main?: string
    hover?: string
    active?: string
}

export type THEME = {
    actionColor?: ButtonColorStyle
    errorColor?: ButtonColorStyle
    successColor?: ButtonColorStyle
}

export interface ButtonProps {
    elementId: string,
    onClick: () => void,
    isAsync?: boolean,
    isDisabled?: boolean,
    type?: BUTTON_TYPE,
    htmlType?: BUTTON_HTML_TYPE,
    size?: BUTTON_SIZE,
    isFullWidth?: boolean,
    isLoading?: boolean,
    gtmAction?: string | undefined,
    gtmLabel?: string,
    children: React.ReactChildren | string | React.ComponentElement<any, any>
    onMouseEnter?: () => React.SyntheticEvent | undefined
    onMouseLeave?: () => React.SyntheticEvent | undefined
}

export default class Button extends React.Component<ButtonProps> {}
